import React from 'react';
import { useSelector } from 'react-redux';
import { Wrapper } from './style';

// Components
import SearchIcon from '@mui/icons-material/Search';
import Input from 'components/common/Input';
import { IconButton, InputAdornment } from '@mui/material';

// Libs
import Translation from 'libs/Translation'

const SearchInput = ({ searchButton, handleSearch, handleChange, value, placeholder, name, defaultValue, style, children, mr, className, autoFocus }) => {
	const {webConfig} = useSelector(state => state.core);

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSearch();
    }

    return(
    <Wrapper onSubmit={handleSubmit}>
        <Input
            name={name}
			handleChange={handleChange}
			value={Translation.n(value)}
			placeholder={placeholder}
            defaultValue={defaultValue}
            className={className}
            autoFocus={autoFocus}
            style={{ fontFamily: webConfig.fontFamily , direction: webConfig.dir, background: 'rgb(244, 244, 244)', borderRadius: '10px', ...style }}
			InputProps={{
                startAdornment: 
                    !searchButton ? (
                        <InputAdornment position="start">
                            <IconButton
                                edge="start"
                                sx={{ mr: webConfig.dir === 'ltr' ? '-20px' : mr ?? '-5px', borderRadius: '10px' }}
                            >
                                <SearchIcon style={{width: '21px', height: '21px', color: '#B2B1B3'}} />
                            </IconButton>
                        </InputAdornment>
                    )
                    : null,
                endAdornment: 
                    searchButton ? (
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                sx={{ mr: webConfig.dir === 'ltr' ? '-10px' : mr ?? '0' }}
                                type='submit'
                                onClick={handleSearch}
                            >
                                <SearchIcon style={{width: '21px', height: '21px', color: 'black'}} />
                            </IconButton>
                        </InputAdornment>
                    )
                    : null
            }}
		>
            {children}
        </Input>
    </Wrapper>
    )
}

export default SearchInput;